import { atomWithReset } from 'jotai/utils';

import type { Me } from './types';

export const initialState = (): Me | null => null;

export const meState = atomWithReset<Me | null>(initialState());
